const binding = { modules: {}, dataActions: {} };

    (binding.modules['nec'] = {
        c: () => require('partner/themes/nec/nec.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','cart','checkout-order-confirmation','checkout','content-block','media-gallery','navigation-menu','promo-banner','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'nec',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'nec.theme.settings.json',
        md: 'src/themes/nec'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };